import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ViewerTicketReport = ({ imprimirContenido }) => {
  const { reprintdata } = useSelector((state) => state.reprint);

  const { cabecera } = reprintdata;
  const { detalle } = reprintdata;

  const fecha = new Date();

  const [porcentaje, setPorcentaje] = useState("0");
  const [montoRecTotal, setMontoRecTotal] = useState(0);
  const [montoARSTotal, setMontoARSTotal] = useState(0);
  const [montoAfilTotal, setMontoAfilTotal] = useState(0);

  /* Variable que guarda la fecha de nacimiento del afiliado */
  const [fechaNac, setFechaNac] = useState(0);

  /* Variable que guarda la edad del afiliado */
  const [Edad, setEdad] = useState(0);

  useEffect(() => {
    const handlemontoRec = () => {
      const sumar = detalle
        ?.map((saldo) => parseFloat(saldo.montototal))
        .reduce((previous, current) => {
          return previous + current;
        }, 0);
      setMontoRecTotal(sumar);
    };

    const handlemontoARS = () => {
      const sumar = detalle
        ?.map((saldo) => parseFloat(saldo.montoars))
        .reduce((previous, current) => {
          return previous + current;
        }, 0);
      setMontoARSTotal(sumar);
    };

    const handlemontoAfil = () => {
      const sumar = detalle
        ?.map((saldo) => parseFloat(saldo.copago))
        .reduce((previous, current) => {
          return previous + current;
        }, 0);
      setMontoAfilTotal(sumar);
    };

    handlemontoRec();
    handlemontoARS();
    handlemontoAfil();
  });

  useEffect(() => {
    if (Array.isArray(cabecera)) {
      const [fechanac] = cabecera?.map((todo, index) => todo.fechanac);
      setFechaNac(fechanac);
    }

    function Edad() {
      var fechaNace = new Date(fechaNac);
      var fechaActual = new Date();

      var mes = fechaActual.getMonth();
      var dia = fechaActual.getDate();
      var año = fechaActual.getFullYear();

      fechaActual.setDate(dia);
      fechaActual.setMonth(mes);
      fechaActual.setFullYear(año);

      let edad = Math.floor(
        (fechaActual - fechaNace) / (1000 * 60 * 60 * 24) / 365
      );

      return edad;
    }

    setEdad(Edad);
  }, [fechaNac, cabecera]);

  useEffect(() => {
    const porcent = Math.round((montoARSTotal / montoRecTotal) * 100);

    setPorcentaje(porcent);
  }, [montoARSTotal, montoRecTotal]);


  /* ------------------------------------ Funciones para crear e imprimir el ticket ------------------------------------ */

  return (
    <>
      <div
        id="contenidoParaImprimir"
        style={{
          width: "290px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "290px",
            textAlign: "center",
          }}
        >
          <tr>
            <td colSpan={2}>*************************************</td>
          </tr>

          <tr>
            <td align="center" style={{ fontWeight: "bold" }}>
              AUTORIZACIÓN DE SERVICIOS MÉDICOS DE SALUD ARS RENACER
            </td>
          </tr>

          <tr>
            <td colSpan={2}>*************************************</td>
          </tr>
        </div>

        <table
          style={{
            width: "290px",
          }}
        >
          {Array.isArray(cabecera)
            ? cabecera.map((item, index) => {
              return (
                <tbody key={index}>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      CÓDIGO AUT:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.codigo}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      CENTRO PSS:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.codpss} {item.nombrE_PSS}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      PÓLIZA:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.codafi}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      NOMBRE AFILIADO:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.comple} {item.apellidos}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      ORIGEN:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.origen}
                    </td>
                  </tr>

                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      SEXO:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.sexo}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      EDAD:{" "}
                    </td>
                    <td
                      align="right"
                      style={{ fontSize: 3, marginRight: "10px" }}
                    >
                      {Edad}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      DIAGNÓSTICO:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.coddia} {item.diagno}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      TELÉFONO:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.telefono}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ fontSize: 3 }}>
                      FECHA AUT:{" "}
                    </td>
                    <td align="right" style={{ fontSize: 3 }}>
                      {item.fechA_AUT}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} />
                  </tr>
                </tbody>
              );
            })
            : null}
        </table>

        <tr>
          <td colSpan={2}>*************************************</td>
        </tr>

        {Array.isArray(detalle)
          ? detalle?.map((item, index) => {
            return (
              <>
                <table
                  style={{
                    width: "290px",
                  }}
                >
                  <thead>
                    <tr>
                      <th align="left" colSpan={3} style={{ fontSize: 3 }}>
                        CÓDIGO
                      </th>
                      <th align="left" colSpan={3} style={{ fontSize: 3 }}>
                        SERVICIOS
                      </th>
                      <th align="left" colSpan={3} style={{ fontSize: 3 }}>
                        CANTIDAD
                      </th>
                      <th align="left" colSpan={3} style={{ fontSize: 3 }}>
                        %
                      </th>
                    </tr>
                  </thead>
                  <tbody key={index}>
                    <tr
                      style={{
                        marginTop: 5,
                        marginBottom: 0,
                      }}
                    >
                      <td align="left" colSpan={3} style={{ fontSize: 3 }}>
                        {item.codproc}
                      </td>

                      <td
                        align="left"
                        colSpan={3}
                        style={{
                          fontSize: 3,
                        }}
                      >
                        {item.servicio.length > 10
                          ? `${item.servicio.substring(0, 8)}...`
                          : item.servicio}
                      </td>

                      <td align="left" colSpan={3} style={{ fontSize: 3 }}>
                        {item.frecuencia}
                      </td>

                      <td align="left" colSpan={3} style={{ fontSize: 3 }}>
                        {porcentaje}
                      </td>
                    </tr>

                    <tr>
                      <tr>
                        <td colSpan={3} />
                      </tr>
                      <tr>
                        <td colSpan={3} />
                      </tr>
                      <tr>
                        <td colSpan={3} />
                      </tr>
                      <tr>
                        <td colSpan={3} />
                      </tr>
                    </tr>
                  </tbody>
                </table>

                <table
                  style={{
                    width: "290px",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        marginTop: 0,
                        marginBottom: 0,
                      }}
                    >
                      <th align="left" colSpan={4} style={{ fontSize: 3 }}>
                        SERV. TOTAL
                      </th>
                      <th align="left" colSpan={4} style={{ fontSize: 3 }}>
                        COB. ARS
                      </th>
                      <th align="left" colSpan={4} style={{ fontSize: 3 }}>
                        DIFERENCIA AFILIADO
                      </th>
                    </tr>
                  </thead>
                  <tbody key={index}>
                    <tr>
                      <td align="left" colSpan={4} style={{ fontSize: 3 }}>
                        {parseFloat(item.montototal)
                          .toFixed(2)
                          .toLocaleString("en")}
                      </td>

                      <td align="left" colSpan={4} style={{ fontSize: 3 }}>
                        {parseFloat(item.montoars)
                          .toFixed(2)
                          .toLocaleString("en")}
                      </td>

                      <td align="left" colSpan={4} style={{ fontSize: 3 }}>
                        {parseFloat(item.copago)
                          .toFixed(2)
                          .toLocaleString("en")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            );
          })
          : null}

        <tr>
          <tr>
            <td colSpan={4} />
          </tr>
          <tr>
            <td colSpan={4} />
          </tr>
          <tr>
            <td colSpan={4} />
          </tr>
          <tr>
            <td colSpan={4} />
          </tr>
        </tr>

        <tr>
          <td colSpan={2}>*************************************</td>
        </tr>
        <table
          style={{
            width: "290px",
          }}
        >
          <tbody>
            <tr>
              <td align="left" colSpan={2} style={{ fontSize: 3 }}>
                TOTAL RECLAMADO:{" "}
              </td>
              <td align="right" colSpan={2} style={{ fontSize: 3 }}>
                $ {parseFloat(montoRecTotal).toFixed(2).toLocaleString("en")}
              </td>
            </tr>

            <tr>
              <td align="left" colSpan={2} style={{ fontSize: 3 }}>
                TOTAL ARS:{" "}
              </td>
              <td align="right" colSpan={2} style={{ fontSize: 3 }}>
                $ {parseFloat(montoARSTotal).toFixed(2).toLocaleString("en")}
              </td>
            </tr>

            <tr>
              <td align="left" colSpan={2} style={{ fontSize: 3 }}>
                TOTAL DIFERENCIA AFILIADO:{" "}
              </td>
              <td align="right" colSpan={2} style={{ fontSize: 3 }}>
                $ {parseFloat(montoAfilTotal).toFixed(2).toLocaleString("en")}
              </td>
            </tr>
          </tbody>
        </table>

        <table
          style={{
            width: "290px",
          }}
        >
          <tbody>
            <tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
            </tr>

            <tr>
              <td align="center" colSpan={2} style={{ fontWeight: "bold" }}>
                ____________________________
              </td>
            </tr>
            <tr>
              <td align="center" colSpan={2} style={{ fontWeight: "bold" }}>
                Entregado Por
              </td>
            </tr>

            <tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
            </tr>

            <td align="center" colSpan={2} style={{ fontWeight: "bold" }}>
              ____________________________
            </td>
            <tr>
              <td align="center" colSpan={2} style={{ fontWeight: "bold" }}>
                Firma Afiliado
              </td>
            </tr>

            <tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
            </tr>
          </tbody>
        </table>

        <table
          style={{
            width: "290px",
          }}
        >
          <tbody>
            <tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
            </tr>

            <tr>
              <td align="center" style={{ fontSize: 3, fontWeight: "normal" }}>
                FECHA RE-IMPRESIÓN:
              </td>
              <td align="start" style={{ fontSize: 3, fontWeight: "normal" }}>
                {fecha.toLocaleString(["ban", "id"])}
              </td>
            </tr>

            <tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
            </tr>

            <tr>
              <td
                align="justify"
                colSpan={2}
                style={{ fontSize: 3, fontWeight: "normal" }}
              >
                Nuestra Política de Calidad: Somos una Administradora de Riesgos
                de Salud, comprometida a proporcionar a nuestros Prestadores de
                Servicios de Salud y a nuestros Afiliados, un servicio oportuno
                y confiable bajo los más altos estándares de calidad, dirigido a
                satisfacer sus necesidades y exceder sus expectativas, aplicando
                un esquema de mejora continua con base en la legislación
                vigente.
              </td>
            </tr>

            <tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
            </tr>

            <tr>
              <td colSpan={2}>*************************************</td>
            </tr>

            <tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
              <tr>
                <td colSpan={2} />
              </tr>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ViewerTicketReport;
